<template>
  <div id="app">
    <!-- 根组件 -->
    <!-- 子路由插入处 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {},
};
</script>

<style></style>
